import { GluestackUIProvider } from "@/components/ui/gluestack-ui-provider"
import { WEB_MOBILE_FRAME_WIDTH } from "@/constants/WebLayout"
import { AuthProvider } from "@/contexts/AuthContext"
import { useColorScheme } from "@/hooks/useColorScheme"
import { initializeSentry, Sentry } from "@/services/sentry"
import FontAwesome from "@expo/vector-icons/FontAwesome"
import { DarkTheme, DefaultTheme, ThemeProvider } from "@react-navigation/native"
import { useFonts } from "expo-font"
import { Slot } from "expo-router"
import * as SplashScreen from "expo-splash-screen"
import { useEffect, useState } from "react"
import { Platform, View } from "react-native"
import { SafeAreaProvider } from "react-native-safe-area-context"

import "../global.css"

initializeSentry()

export {
  // Catch any errors thrown by the Layout component.
  ErrorBoundary,
} from "expo-router"

// export const unstable_settings = {
//   // Ensure that reloading on `/modal` keeps a back button present.
//   initialRouteName: "gluestack",
// };

// Prevent the splash screen from auto-hiding before asset loading is complete.
SplashScreen.preventAutoHideAsync()

function RootLayout() {
  const [loaded, error] = useFonts({
    SpaceMono: require("../assets/fonts/SpaceMono-Regular.ttf"),
    ...FontAwesome.font,
  })

  const [styleLoaded, setStyleLoaded] = useState(false)
  // Expo Router uses Error Boundaries to catch errors in the navigation tree.
  useEffect(() => {
    if (error) throw error
  }, [error])

  useEffect(() => {
    if (loaded) {
      SplashScreen.hideAsync()
    }
  }, [loaded])

  // useLayoutEffect(() => {
  //   setStyleLoaded(true);
  // }, [styleLoaded]);

  // if (!loaded || !styleLoaded) {
  //   return null;
  // }

  return <RootLayoutNav />
}

export default Sentry.wrap(RootLayout)

function RootLayoutNav() {
  const colorScheme = useColorScheme()
  const isWeb = Platform.OS === "web"

  return (
    <View style={{ flex: 1, ...(isWeb ? { alignItems: "center" } : null) }}>
      <View
        style={{
          flex: 1,
          width: "100%",
          ...(isWeb ? { maxWidth: WEB_MOBILE_FRAME_WIDTH } : null),
        }}
      >
        <SafeAreaProvider>
          <GluestackUIProvider mode={colorScheme === "dark" ? "dark" : "light"}>
            <ThemeProvider value={colorScheme === "dark" ? DarkTheme : DefaultTheme}>
              <AuthProvider>
                <Slot />
              </AuthProvider>
            </ThemeProvider>
          </GluestackUIProvider>
        </SafeAreaProvider>
      </View>
    </View>
  )
}
